<style lang="scss">
  .video-section {
    position: relative;
    margin-top: 40px;

    @media screen and (min-width: 1024px) {
      margin-top: 0;
    }
    .video-thumbnail {
      border-radius: 6px 6px 0 0;
      aspect-ratio: 16/12;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
      position: relative;
      cursor: pointer;
      overflow: hidden;
      &:hover .play-text {
        transition: color 0.15s ease-in-out;
        color: red;
      }
      &:hover .play-button {
        transition: transform 0.15s ease-in-out;
        transform: scale(1.5);
        -webkit-transform: scale(1.5);
      }
      &:hover img {
        transform: scale(1.2);
      }

      img {
        transition: all 0.3s;
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-fit: center;
      }

      &:after {
      }
    }

    .video-title {
      color: #004373;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 28px;
    }
    .row {
      border-radius: 0 0 6px 6px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
      @media screen and (min-width: 1024px) {
        min-height: 160px;
      }
      @media screen and (min-width: 1400px) {
        min-height: auto;
      }
    }

    .job-link {
      color: #f99337;
      font-weight: 500;
      letter-spacing: 2px;
      line-height: 21px;

      &:after {
        height: 21px;
      }
    }
  }
</style>

<template>
  <div class="video-section w-full flex flex-col lg:w-auto" @click="open()">
    <div v-if="videoId != null && videoId != ''" class="video-thumbnail">
      <img :src="thumbnailImage" alt="variofood-video" />
      <div class="inset-0 absolute flex items-center justify-center w-full h-full">
        <span class="play-video"></span>
      </div>
    </div>
    <div v-else class="video-thumbnail">
      <img :src="thumbnailImage" alt="variofood-thumbnail" />
    </div>
    <div class="row bg-white flex flex-1">
      <a class="flex-1 flex flex-col" :href="lang.locale + '/jobs/' + jobSlug">
        <p class="video-title p-16 pb-16">{{ videoTitle }}</p>
        <p class="job-link px-16 mt-auto pb-16 uppercase cta-orange-arrow-right">
          {{ lang.apply }}
        </p>
      </a>
    </div>
    <video-modal :video-id="videoId" :open="showVideo" @close="close"></video-modal>
  </div>
</template>

<script>
  export default {
    props: {
      videoId: {
        type: String,
        required: false,
      },
      videoTitle: {
        type: String,
        required: false,
      },
      jobSlug: {
        type: String,
        required: false,
      },
      forwardVideo: {
        type: String,
        required: false,
      },
      thumbnailImage: {
        type: String,
        required: false,
      },
      lang: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        showVideo: false,
        thumbnail: "",
      };
    },
    mounted() {
      // functin to fetch correct thumbnail image form vimeo video json, not necessary anymore because thumbnail comes from WP
      // var request = new XMLHttpRequest();
      // var url = "https://vimeo.com/api/v2/video/" + this.videoId +".json";
      //
      // fetch(url)
      //     .then(res => res.json())
      //     .then((out) => {
      //       this.thumbnail = out[0].thumbnail_large;
      //     })
      //     .catch(err => { throw err });
    },
    methods: {
      open() {
        if (this.forwardVideo != true) {
          this.showVideo = true;
        } else {
          window.location.href = this.lang.locale + "/jobs/" + this.jobSlug;
        }
      },
      close() {
        this.showVideo = false;
      },
    },
  };
</script>
